var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.004 28.747L17.21 6l12.675 22.747H5.004zm9.562-24.165L2.36 27.329c-1.073 1.998.375 4.418 2.643 4.418h24.88c2.29 0 3.735-2.46 2.62-4.46L19.83 4.54c-1.154-2.072-4.143-2.048-5.264.042zm1.424 8.61a1 1 0 011-1h1.222a1 1 0 011 1v7.472a1 1 0 01-1 1H16.99a1 1 0 01-1-1v-7.472zm0 11.083a1 1 0 011-1h1.222a1 1 0 011 1v1.222a1 1 0 01-1 1H16.99a1 1 0 01-1-1v-1.222z",
    fill: "currentColor"
  })));
}

export default SvgWarningError;